import React, { useContext } from 'react'
import { Box, Flex, Text, Image } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import { locationIcon, livelessonIcon } from '../../assets'
import Avatar from 'src/components/Avatar/Avatar'
import { Language } from '../../types/index'
import LanguageIconsWithText from '../LanguageIconsWithText/LanguageIconsWithText'

import { ThemeContext } from 'styled-components'

type Props = {
  name: string
  login: string
  location: string
  liveLessonCount: number
  avatarUrl: string
  approvedLanguages: Language[]
  fluentLanguages: Language[]
}

const UserCard: React.FC<Props> = ({
  name,
  login,
  location,
  liveLessonCount,
  avatarUrl,
  approvedLanguages,
  fluentLanguages,
}) => {
  const themeContext = useContext(ThemeContext)
  const { black19 } = themeContext.colors
  return (
    <Flex
      flexDirection={{ _: 'column-reverse', tablet: 'row' }}
      flexGrow="1"
      justifyContent="space-between"
    >
      <Flex mb="0,5x" flexDirection="column">
        <Flex
          variant="text.h3"
          alignSelf={{ _: 'center', tablet: 'flex-start' }}
        >
          <Box
            as="a"
            textAlign="center"
            style={{
              textDecoration: 'none',
              color: black19,
            }}
            href={`/${login}`}
          >
            {name}
          </Box>
        </Flex>
        <Flex />

        <Text
          fontSize="xs"
          mb="2x"
          fontFamily="Courier"
          color="gray46"
          alignSelf={{ _: 'center', tablet: 'flex-start' }}
        >
          {login}
        </Text>

        {location && (
          <Flex
            alignItems="flex-start"
            mb="1x"
            justifyContent={{ _: 'center', tablet: 'flex-start' }}
          >
            <Image src={locationIcon} mr="0,5x" alt="" />
            <Text fontSize="sm">{location}</Text>
          </Flex>
        )}
        {liveLessonCount > 0 && (
          <Flex
            alignItems="flex-start"
            mb="1x"
            justifyContent={{ _: 'center', tablet: 'flex-start' }}
          >
            <Image src={livelessonIcon} mr="0,5x" alt="" />
            <Text fontSize="sm">{`${liveLessonCount} Lessons tutored`}</Text>
          </Flex>
        )}
        {approvedLanguages && (
          <LanguageIconsWithText
            languages={approvedLanguages}
            text={t('Teaches')}
          />
        )}

        {fluentLanguages && (
          <LanguageIconsWithText
            languages={fluentLanguages}
            text={t('Speaks')}
          />
        )}
      </Flex>
      <Flex
        alignSelf={{ _: 'center', tablet: 'flex-end' }}
        mb={{ _: '3x', tablet: null }}
      >
        <Avatar
          // without languageCode="" children={null} ts complains
          languageCode=""
          children={null}
          url={avatarUrl}
          size="xxl"
        />
      </Flex>
    </Flex>
  )
}

export default UserCard
